// Shared classification and total for Leases' Reduce exposure band and
// portfolio reports. Keep this module dependency-free so both browser and
// server report code can use the same eligibility rule.

const SERVICED_FLEXIBLE_TYPES = new Set(["serviced_office", "flexible"]);
const WIND_DOWN_STATUSES = new Set(["wind_down", "winding_down", "exit", "exit_hold"]);

export function isVacatedLease(lease) {
  return lease.locationStage === "vacated" || lease.leaseStatus === "vacant_held";
}

export function isOutboundSublease(lease) {
  return lease.leaseStatus === "sublease_out"
    || lease.leaseType === "sublease_outbound"
    || lease.type === "sublease_outbound";
}

export function assignVacatedPosture(lease) {
  if (lease.leaseStatus === "sublease_out") return "sublease";
  if (WIND_DOWN_STATUSES.has(lease.leaseStatus) || SERVICED_FLEXIBLE_TYPES.has(lease.leaseType)) {
    return "winding-down";
  }
  return "sublease";
}

export function isReduceExposureLease(lease) {
  return (isVacatedLease(lease) || isOutboundSublease(lease))
    && lease.status !== "expired"
    && lease.status !== "draft";
}

export function selectReduceExposureAtRiskLeases(leases) {
  return (leases || []).filter((lease) => {
    if (lease.action_window_bucket === "reduce-exposure") return lease.posture === "sublease";
    return isReduceExposureLease(lease) && assignVacatedPosture(lease) === "sublease";
  });
}

export function sumReduceExposureAtRiskAnnualRent(leases) {
  return selectReduceExposureAtRiskLeases(leases)
    .reduce((sum, lease) => sum + Number(lease.annualRentUsd ?? 0), 0);
}